import React from 'react';
import { bool, oneOf, string } from 'prop-types';
import classNames from 'classnames/bind';

import styles from './Icon.module.scss';

const cx = classNames.bind(styles);

const Icon = ({ name, fill, className }) => (
  <i
    className={cx('icon', name, { fill }, className)}
    data-qa={`${name}-icon`}
  />
);

// TODO: 'tick' and 'confirmed-alt-2' are the same icon, please change to 'tick' wherever relevant
Icon.propTypes = {
  name: oneOf([
    'minus',
    'plus',
    'heart',
    'eye',
    'close',
    'arrow',
    'play',
    'pause',
    'tick',
    'directions',
    'edit',
    'ruler',
    'ui-video',
    'empty-bag',
    'shopping-bag',
    'chevron',
    'info',
    'search',
    'confirmed-alt-2',
    'help',
    'user',
    'barcode',
  ]).isRequired,
  fill: bool,
  className: string,
};

Icon.defaultProps = {
  fill: false,
  className: null,
};

export { Icon };
